import React from "react"
import HeroImageStyle from "./HeroImageStyle.module.styl"
import Image from "gatsby-image"

const HeroImage = ({ images }) => {
  const heroImage = images[0].node.childImageSharp.fluid
  return (
    <div className={HeroImageStyle.image_holder}>
      <Image alt="hero-image" fluid={heroImage} />
    </div>
  )
}

export default HeroImage
